'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.makeBatchReducer = makeBatchReducer;

var _fsa = require('@zaibot/fsa');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function makeBatchReducer(descriptor, options) {
    let actions = descriptor.actions;

    let emptyState = {
        creating: false,
        deleting: false,
        error: null,
        item: {},
        items: [],
        reading: false,
        updating: false
    };
    return function () {
        let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : emptyState;
        let action = arguments[1];

        if ((0, _fsa.isType)(action, actions.APPLY)) {
            return (0, _extends3.default)({}, state, { item: (0, _extends3.default)({}, state.item, action.payload.item)
            });
        } else if ((0, _fsa.isType)(action, actions.CREATE)) {
            return (0, _extends3.default)({}, state, { creating: true, items: action.payload.items, item: {} });
        } else if ((0, _fsa.isType)(action, actions.CREATE_CANCEL)) {
            return (0, _extends3.default)({}, state, { creating: false, items: [], item: {} });
        } else if ((0, _fsa.isType)(action, actions.CREATE_CONTINUE)) {
            return (0, _extends3.default)({}, state, { creating: false });
        } else if ((0, _fsa.isType)(action, actions.READ)) {
            return (0, _extends3.default)({}, state, { reading: true, items: action.payload.items, item: {} });
        } else if ((0, _fsa.isType)(action, actions.READ_CANCEL)) {
            return (0, _extends3.default)({}, state, { reading: false, items: [], item: {} });
        } else if ((0, _fsa.isType)(action, actions.READ_CONTINUE)) {
            return (0, _extends3.default)({}, state, { reading: false });
        } else if ((0, _fsa.isType)(action, actions.UPDATE)) {
            return (0, _extends3.default)({}, state, { updating: true, items: action.payload.items, item: {} });
        } else if ((0, _fsa.isType)(action, actions.UPDATE_CANCEL)) {
            return (0, _extends3.default)({}, state, { updating: false, items: [], item: {} });
        } else if ((0, _fsa.isType)(action, actions.UPDATE_CONTINUE)) {
            return (0, _extends3.default)({}, state, { updating: false });
        } else if ((0, _fsa.isType)(action, actions.DELETE)) {
            return (0, _extends3.default)({}, state, { deleting: true, items: action.payload.items, item: {} });
        } else if ((0, _fsa.isType)(action, actions.DELETE_CANCEL)) {
            return (0, _extends3.default)({}, state, { deleting: false, items: [], item: {} });
        } else if ((0, _fsa.isType)(action, actions.DELETE_CONTINUE)) {
            return (0, _extends3.default)({}, state, { deleting: false });
        } else if ((0, _fsa.isType)(action, actions.RESET)) {
            return (0, _extends3.default)({}, state, { creating: false, reading: false, updating: false, deleting: false, items: [], item: {} });
        } else {
            return state;
        }
    };
}
//# sourceMappingURL=makeBatchReducer.js.map


// WEBPACK FOOTER //
// ./node_modules/redux-saga-resources/node/batch/makeBatchReducer.js